import { BellOutlined } from "@ant-design/icons";
import { Badge } from "antd";

import { useGetNotificationsDatabaseUnreadCount } from "@/entities/notifications-database";
import { NavButton } from "@/modules/nav-button";
import { NotificationsPanel } from "@/modules/notifications/notifications-panel";

import "./nav-button-notifications.style.less";

export const NavButtonNotifications = () => {
  const { unreadCount } = useGetNotificationsDatabaseUnreadCount();

  return (
    <NotificationsPanel>
      <Badge
        count={unreadCount}
        overflowCount={9}
        className="nav-button-notifications-badge"
        classNames={{ indicator: "nav-button-notifications-badge--indicator" }}
      >
        <NavButton icon={<BellOutlined />} />
      </Badge>
    </NotificationsPanel>
  );
};
